import { observable, set, computed } from 'mobx';
import { IContentObjListItem, IArticleObjItem } from '../../interfaces/ISearchInterfaces';
import { RESULT_TYPE } from '../../constants/Search';

export interface ISearchArticleCatalog {
    contentObjListItems: IContentObjListItem[];
}

export class SearchArticleCatalog {
    @observable private contentItems: IContentObjListItem[] = [];
    @observable private articleItems: IArticleObjItem[] = [];

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public static fromJSON(data: any): SearchArticleCatalog {
        const searchArticleCatalog = new SearchArticleCatalog();
        set(searchArticleCatalog, data);

        return searchArticleCatalog;
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public update = (data: any) => {
        set(this, data);
        this.contentItems = [];
        this.articleItems = [];

        const catalog: ISearchArticleCatalog = {
            contentObjListItems: data.contentObjListItems
        };

        if (catalog.contentObjListItems.length) {
            this.contentItems = catalog.contentObjListItems;

            this.contentItems.forEach(contentObjListItem => {
                switch (contentObjListItem.type) {
                    case RESULT_TYPE.ARTICLE:
                        const article = this.createArticle(contentObjListItem);
                        this.articleItems.push(article);
                        break;

                    default:
                }
            });
        }
    };

    private createArticle(articleItem: IContentObjListItem): IArticleObjItem {
        const articleAttributes = articleItem.articles[0].attributes;

        const article: IArticleObjItem = {
            nId: articleItem.nId,
            templateTitle: articleAttributes.c_template_title[0],
            uri: articleAttributes.c_uri[0],
            urlAlias: articleAttributes.c_url_alias[0]
        };

        return article;
    }

    @computed
    public get content() {
        return this.contentItems;
    }

    @computed
    public get articles() {
        return this.articleItems;
    }

    @computed
    public get numContentRecs() {
        return {
            articlesRecNumber: this.articleItems.length
        };
    }
}
